export default ($api) => (
  {
    donvihanhchinh: (ma) => {
      return $api.get(`/donvihanhchinh/tree/${ma}`)
    },
    linhvuc: (data) => {
      return $api.get(`/linh-vucs`, { params: data })
    },
  })
